import React from 'react';
import { useAuth } from '../../context/AuthContext';
import {useNavigate} from 'react-router-dom';
import SPLogo from '../../assets/SPLogoName.png';
import Calendar from '../../assets/icons/Calendar.svg';
import Clock from '../../assets/icons/Clock.svg';
import Codepen from '../../assets/icons/Codepen.svg';
import Users from '../../assets/icons/Users.svg';
import PieChart from '../../assets/icons/Pie_chart.svg';
import Logout from '../../assets/icons/Log_out.svg';


const navigation = [

    {
        name: 'Dashboard',
        path: '/dashboard',
        icon: PieChart,
    },
    {
        name: 'Einsatzplanung',
        path: '/eventmatching',
        icon: Calendar,
        children: [
            {name: 'Plantafel', path: '/plantafel'},
            {name: 'Import', path: '/eventImport'},
        ],
    },
    {
        name: 'Leistungspakete',
        path: '/leistungspaketeAuswahl',
        icon: Codepen,
        children: [
            {name: 'Auswertung', path: '/leistungspakete'},
            {name: 'Import', path: '/leistungspakete/import'},
        ],
    },
    {
        name: 'Stundenkontingente',
        path: '/stundenkontingenteAuswahl',
        icon: Clock,
        children: [
            {name: 'Auswertung', path: '/stundenkontingente'},
            {name: 'Import', path: '/stundenkontingente/import'},
            {name: 'Spezialauswertung', path: '/stundenkontingente/import/special'},
        ],
    },
    {
        name: 'Personal',
        path: '/personal',
        icon: Users,
        children: [
            {name: 'Prognose', path: '/personal/forecast'},
        ],
    },
];


const MenuSidebar = ({isOpen, onClose}) => {
    const navigate = useNavigate();

    const { logout } = useAuth();

    const handleLogout = () => {
        logout();
        navigate('/login', { replace: true });
    };

    return (
        <div
            className={`fixed top-0 left-0 w-64 h-full bg-gray-800 rounded-tr-xl rounded-br-xl shadow-xl z-50 transform transition-transform duration-300 ease-in-out ${
                isOpen ? 'translate-x-0' : '-translate-x-full'
            } flex flex-col`} // <-- direkt hier flex-col setzen!
        >
            {/* Logo */}
            <div className="flex items-center justify-center mt-8 mb-12">
                <img src={SPLogo} alt="Logo" className="h-24 w-auto"/>
            </div>

            {/* Navigation */}
            <nav className="flex flex-col space-y-6 px-4">
                {navigation.map((item) => (
                    <div key={item.name}>
                        <button
                            onClick={() => {
                                navigate(item.path);
                                onClose();
                            }}
                            className="group flex items-center gap-x-3 px-3 py-2 rounded-md text-sm font-medium text-gray-200 hover:bg-gray-700 hover:text-white transition w-full"
                        >
                            <img
                                src={item.icon}
                                alt=""
                                className="h-5 w-5 shrink-0 opacity-80 group-hover:opacity-100 invert"
                            />
                            <span>{item.name}</span>
                        </button>

                        {item.children && (
                            <div className="ml-9 mt-2 flex flex-col space-y-1">
                                {item.children.map((child) => (
                                    <button
                                        key={child.name}
                                        onClick={() => {
                                            navigate(child.path);
                                            onClose();
                                        }}
                                        className="text-left text-sm text-gray-400 hover:text-indigo-300 transition"
                                    >
                                        {child.name}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </nav>

            {/* Logout Button fix am unteren Rand */}
            <div className="mt-auto px-4 pb-6">
                <button
                    onClick={handleLogout}
                    className="group flex items-center gap-x-3 px-3 py-2 rounded-md text-sm font-medium text-red-400 hover:bg-red-600 hover:text-white transition w-full"
                >
                    <span>Logout</span>
                    <img
                        src={Logout}
                        alt=""
                        className="h-5 w-5 shrink-0 opacity-80 group-hover:opacity-100 invert"
                    />
                </button>
            </div>
        </div>


    );
};

export default MenuSidebar;
